function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 43.3816,
  y: 37.6059,
  width: 96.6457,
  height: 63.3124,
  fill: "#fff"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M111.8438,208.9222a80.9942,80.9942,0,0,1,21.5629-75.4752,80.0088,80.0088,0,0,1,39.87-21.6033,2.5224,2.5224,0,0,0,2.0161-2.46V63.6169a15.2334,15.2334,0,0,0-4.4255-10.6957L136.4612,18.5051A15.2534,15.2534,0,0,0,125.7654,14.06H29.12A15.1268,15.1268,0,0,0,13.9991,29.1808v75.6063a5.0422,5.0422,0,0,0,5.04,5.04H26.6a2.5212,2.5212,0,0,1,2.52,2.52v20.1617a2.5211,2.5211,0,0,1-2.52,2.52H19.04a5.0423,5.0423,0,0,0-5.04,5.0405v75.6063A15.1268,15.1268,0,0,0,29.12,230.7977h87.0682a2.5255,2.5255,0,0,0,2.51-2.55,2.491,2.491,0,0,0-.2621-1.1089A78.141,78.141,0,0,1,111.8438,208.9222ZM97.1761,49.3425V89.6658a7.5606,7.5606,0,1,1-15.1212,0V49.3425a7.5606,7.5606,0,1,1,15.1212,0Zm-35.2829,0V89.6658a7.5607,7.5607,0,1,1-15.1213,0V49.3425a7.5607,7.5607,0,1,1,15.1213,0Zm70.5659,40.3233a7.5607,7.5607,0,1,1-15.1213,0V49.3425a7.5607,7.5607,0,1,1,15.1213,0Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M254.2357,175.353a64.7351,64.7351,0,0,0-48.7005-48.6905,65.6521,65.6521,0,0,0-78.9432,78.9331,64.7282,64.7282,0,0,0,48.7006,48.7207A67.8753,67.8753,0,0,0,190.313,256a65.5415,65.5415,0,0,0,63.9227-80.6468ZM150.7961,212.33a2.2794,2.2794,0,0,1-.4636-.6553,44.7791,44.7791,0,0,1,8.0646-53.2269,46.4559,46.4559,0,0,1,53.3176-8.0747,2.51,2.51,0,0,1,.5746,4.0323L154.3648,212.34A2.5282,2.5282,0,0,1,150.7961,212.33ZM211.624,230.586a45.4613,45.4613,0,0,1-42.4908,0v.03a2.5155,2.5155,0,0,1-1.0383-3.4073,2.5826,2.5826,0,0,1,.4637-.625l57.9951-57.9951a2.4688,2.4688,0,0,1,2.1372-.7057,2.5169,2.5169,0,0,1,1.8548,1.28A45.4462,45.4462,0,0,1,211.624,230.586Z",
  fill: "red"
});

var SvgWebappIconSdCardRemovedLightTheme = function SvgWebappIconSdCardRemovedLightTheme(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWebappIconSdCardRemovedLightTheme, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/webapp-icon-sd-card-removed-light-theme.125ae181.svg";
export { ForwardRef as ReactComponent };